import React, { useState } from "react";
import { BiX, BiCalendar } from "react-icons/bi";

const periods = [
  { value: "today", label: "Aujourd'hui" },
  { value: "week", label: "7 derniers jours" },
  { value: "month", label: "30 derniers jours" },
  { value: "quarter", label: "3 derniers mois" },
  { value: "year", label: "12 derniers mois" },
  { value: "custom", label: "Personnalisé" },
];

const ReportFilters = ({ filters, onChange, onClose }) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const [showCustom, setShowCustom] = useState(filters.period === "custom");

  const handlePeriodChange = (period) => {
    setLocalFilters({ ...localFilters, period });
    setShowCustom(period === "custom");
  };

  const handleDateChange = (type, value) => {
    setLocalFilters({ ...localFilters, [type]: value });
  };

  const applyFilters = () => {
    onChange(localFilters);
    onClose();
  };

  const resetFilters = () => {
    const defaultFilters = { period: "month", startDate: null, endDate: null };
    setLocalFilters(defaultFilters);
    onChange(defaultFilters);
    onClose();
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-lg mb-6">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center">
        <h3 className="font-poppins font-semibold text-[16px]">Filtres</h3>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
          <BiX size={20} />
        </button>
      </div>

      <div className="p-4 space-y-4">
        {/* Période */}
        <div>
          <label className="block font-nunito text-[14px] font-medium text-text mb-2">
            Période
          </label>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
            {periods.map((period) => (
              <button
                key={period.value}
                onClick={() => handlePeriodChange(period.value)}
                className={`px-3 py-2 text-sm rounded-lg border transition-colors ${
                  localFilters.period === period.value
                    ? "bg-secondary-500 text-white border-secondary-500"
                    : "border-gray-300 hover:bg-gray-50"
                }`}
              >
                {period.label}
              </button>
            ))}
          </div>
        </div>

        {/* Dates personnalisées */}
        {showCustom && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block font-nunito text-[14px] font-medium text-text mb-2">
                Date de début
              </label>
              <div className="relative">
                <BiCalendar className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="date"
                  value={localFilters.startDate || ""}
                  onChange={(e) =>
                    handleDateChange("startDate", e.target.value)
                  }
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg font-nunito text-[14px] focus:outline-none focus:ring-2 focus:ring-secondary-500"
                />
              </div>
            </div>
            <div>
              <label className="block font-nunito text-[14px] font-medium text-text mb-2">
                Date de fin
              </label>
              <div className="relative">
                <BiCalendar className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="date"
                  value={localFilters.endDate || ""}
                  onChange={(e) => handleDateChange("endDate", e.target.value)}
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg font-nunito text-[14px] focus:outline-none focus:ring-2 focus:ring-secondary-500"
                />
              </div>
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
          <button
            onClick={resetFilters}
            className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Réinitialiser
          </button>
          <button
            onClick={applyFilters}
            className="px-4 py-2 text-sm bg-secondary-500 text-white rounded-lg hover:bg-secondary-600 transition-colors"
          >
            Appliquer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportFilters;
